<template>
  <!-- label-width="80px" -->
  <div class="page-container">
    <div class="page-title">{{$t('upgrade_page_views_withdraw_save_info_2352')}}</div>
    <el-form :model="withdrawData" class="message-info">
      <div class="from-title">{{$t('upgrade_page_views_withdraw_save_info_2353')}}</div>
      <el-form-item :label="$t('upgrade_page_views_withdraw_save_info_2354')">
        <el-input
          v-model="withdrawData.memberUnified"
          :class="errors.memberUnified && !withdrawData.memberUnified && 'errors-style'"
          maxlength="10"
          :placeholder="$t('upgrade_page_views_withdraw_save_info_2355')"
          @change="idCardNumberVerify"
        ></el-input>
        <span v-show="errors.memberUnified" class="text-error">{{$t('upgrade_page_views_withdraw_save_info_2356')}}</span>
      </el-form-item>
      <el-form-item :label="$t('upgrade_page_views_withdraw_save_info_2357')">
        <el-input
          v-model="withdrawData.idCardDate"
          :class="errors.idCardDate && 'errors-style'"
          maxlength="7"
          type="number"
          :placeholder="$t('upgrade_page_views_withdraw_save_info_2358')"
          @change="idCardVerify"
        ></el-input>
        <span v-show="errors.idCardDate" class="text-error">{{$t('upgrade_page_views_withdraw_save_info_2358')}}</span>
      </el-form-item>
      <el-form-item :label="$t('upgrade_page_views_withdraw_save_info_2359')">
        <el-select v-model="withdrawData.idCardPlace" :class="errors.idCardPlace && !withdrawData.idCardPlace && 'errors-style'" placeholder="--">
          <el-option
            v-for="(obj, i) in IDCardPlaceList"
            :key="'place-' + i"
            :label="obj.label"
            :value="obj.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('upgrade_page_views_withdraw_save_info_2360')">
        <el-select v-model="withdrawData.idPic" :class="errors.idPic && !withdrawData.idPic && 'errors-style'" placeholder="--">
          <el-option
            v-for="obj in idPicList"
            :key="obj.value"
            :label="obj.label"
            :value="obj.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('upgrade_page_views_withdraw_save_info_2361')">
        <el-select v-model="withdrawData.idFrom" :class="errors.idFrom && !withdrawData.idFrom && 'errors-style'" placeholder="--">
          <el-option
            v-for="obj in idFromList"
            :key="obj.value"
            :label="obj.label"
            :value="obj.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('upgrade_page_views_withdraw_save_info_2362')">
        <div class="UploadIDCard">
          <div class="UploadIDCard_Positive">
            <span class="Positive_title">{{$t('upgrade_page_views_withdrawalbenfit_withdraw_info_1647')}}</span>
            <el-upload
              class="avatar-uploader"
              action="https://api.dev.nicee.app/basic/image/upload"
              :show-file-list="false"
              :http-request="handleAvatarSuccessP"
              :before-upload="beforeAvatarUpload">
              <img v-if="withdrawData.idCardImage" :src="withdrawData.idCardImage" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div v-show="errors.idCardImage" slot="tip" class="el-upload__text upload__tip">{{$t('upgrade_page_views_withdrawalbenfit_withdraw_info_1648')}}</div>
          </div>
          <div class="UploadIDCard_Verso">
            <span class="Verso_title">{{$t('upgrade_page_views_withdrawalbenfit_withdraw_info_1649')}}</span>
            <el-upload
              class="avatar-uploader"
              action="https://api.dev.nicee.app/basic/image/upload"
              :show-file-list="false"
              :http-request="handleAvatarSuccessO"
              :before-upload="beforeAvatarUpload">
              <img v-if="withdrawData.idCardImageBack" :src="withdrawData.idCardImageBack" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div v-show="errors.idCardImageBack" slot="tip" class="el-upload__text upload__tip">{{$t('upgrade_page_views_withdrawalbenfit_withdraw_info_1650')}}</div>
          </div>
          <div class="IDCard_dec">
            <p>{{$t('upgrade_page_views_withdrawalbenfit_withdraw_info_1651')}}</p>
            <p>{{$t('upgrade_page_views_withdrawalbenfit_withdraw_info_1652')}}</p>
            <p>{{$t('upgrade_page_views_withdrawalbenfit_withdraw_info_1653')}}</p>
          </div>
        </div>
      </el-form-item>
      <el-form-item :label="$t('upgrade_page_views_withdraw_save_info_2363')">
        <el-input
          v-model="withdrawData.memberName"
          :class="errors.memberName && !withdrawData.memberName && 'errors-style'"
          maxlength="20"
          :placeholder="$t('upgrade_page_views_withdraw_save_info_2364')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('upgrade_page_views_withdraw_save_info_2365')">
        <el-input
          v-model="withdrawData.memberPhone"
          :class="errors.memberPhone && 'errors-style'"
          maxlength="13"
          :placeholder="$t('upgrade_page_views_withdraw_save_info_2366')"
          @change="memberPhoneVerify"
        ></el-input>
        <span v-show="errors.memberPhone" class="text-error">{{$t('upgrade_page_views_withdraw_save_info_2366')}}</span>
      </el-form-item>
      <el-form-item :label="$t('upgrade_page_views_withdraw_save_info_2367')">
        <el-input
          v-model="withdrawData.managerNameE"
          :class="errors.managerNameE && 'errors-style'"
          maxlength="20"
          :placeholder="$t('upgrade_page_views_withdraw_save_info_2368')"
          @change="managerNameEVerify"
        ></el-input>
        <span v-show="errors.managerNameE" class="text-error">{{$t('upgrade_page_views_withdraw_save_info_2368')}}</span>
      </el-form-item>
      <el-form-item :label="$t('upgrade_page_views_withdraw_save_info_2369')">
        <el-input
          v-model="withdrawData.managerMobile"
          :class="errors.managerMobile && 'errors-style'"
          maxlength="10"
          type="number"
          :placeholder="$t('upgrade_page_views_withdraw_save_info_2370')"
          @change="managerMobileVerify"
        ></el-input>
        <span v-show="errors.managerMobile" class="text-error">{{$t('upgrade_page_views_withdraw_save_info_2370')}}</span>
      </el-form-item>
      <el-form-item label="E-mail">
        <el-input
          v-model="withdrawData.managerEmail"
          :class="errors.managerEmail && 'errors-style'"
          maxlength="40"
          :placeholder="$t('upgrade_page_views_withdraw_save_info_2371')"
          @change="managerEmailVerify"
        ></el-input>
        <span v-show="errors.managerEmail" class="text-error">{{$t('upgrade_page_views_withdraw_save_info_2371')}}</span>
      </el-form-item>
      <div class="from-title">{{$t('upgrade_page_views_withdraw_save_info_2372')}}</div>
      <el-form-item :label="$t('upgrade_page_views_withdrawalbenfit_withdrawatm_1627')">
        <el-input
          v-model="withdrawData.loginAccount"
          :class="errors.loginAccount && 'errors-style'"
          maxlength="20"
          :placeholder="$t('upgrade_page_views_withdraw_save_info_2373')"
          @change="loginAccountVerify"
        ></el-input>
        <span v-show="errors.loginAccount" class="text-error">{{$t('upgrade_page_views_withdraw_save_info_2373')}}</span>
      </el-form-item>
      <el-form-item :label="$t('upgrade_page_views_withdraw_save_info_2374')">
        <el-input v-model="withdrawData.merchantAddrCity" :class="errors.merchantAddrCity && !withdrawData.merchantAddrCity && 'errors-style'" maxlength="5" :placeholder="$t('upgrade_page_views_withdraw_save_info_2375')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('upgrade_page_views_withdraw_save_info_2376')">
        <el-input v-model="withdrawData.merchantAddrArea" :class="errors.merchantAddrArea && !withdrawData.merchantAddrArea && 'errors-style'" maxlength="5" :placeholder="$t('upgrade_page_views_withdraw_save_info_2377')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('upgrade_page_views_withdraw_save_info_2378')">
        <el-input v-model="withdrawData.merchantAddrCode" :class="errors.merchantAddrCode && !withdrawData.merchantAddrCode && 'errors-style'" maxlength="3" :placeholder="$t('upgrade_page_views_withdraw_save_info_2379')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('upgrade_page_views_withdraw_save_info_2380')">
        <el-input v-model="withdrawData.merchantAddr" :class="errors.merchantAddr && !withdrawData.merchantAddr && 'errors-style'" maxlength="60" :placeholder="$t('upgrade_page_views_withdraw_save_info_2381')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('upgrade_page_views_withdraw_save_info_2382')">
        <el-input v-model="withdrawData.cityE" :class="errors.cityE && !withdrawData.cityE && 'errors-style'" maxlength="20" :placeholder="$t('upgrade_page_views_withdraw_save_info_2383')"></el-input>
      </el-form-item>
      <div class="from-title">{{$t('upgrade_page_views_withdraw_save_info_2384')}}</div>
      <el-form-item :label="$t('upgrade_page_views_withdraw_save_info_2385')">
        <el-select v-model="withdrawData.bankCode" :class="errors.bankCode && !withdrawData.bankCode && 'errors-style'" placeholder="--" @change="handleSelectBank">
          <el-option
            v-for="(obj, i) in BankList"
            :key="'place-' + i"
            :label="obj.bankCode + ' ' + obj.bankName"
            :value="obj.bankCode"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('upgrade_page_views_withdraw_save_info_2386')">
        <el-input v-model="withdrawData.subBankCode" :class="errors.subBankCode && !withdrawData.subBankCode && 'errors-style'" maxlength="4" :placeholder="$t('upgrade_page_views_withdraw_save_info_2387')" type="number"></el-input>
      </el-form-item>
      <el-form-item :label="$t('upgrade_page_views_withdraw_save_info_2388')">
        <el-input v-model="withdrawData.bankAccount" :class="errors.bankAccount && !withdrawData.bankAccount && 'errors-style'" maxlength="30" :placeholder="$t('upgrade_page_views_withdraw_save_info_2389')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('upgrade_page_views_withdrawalbenfit_withdraw_info_1664')">
        <div class="uploadBankbook">
          <div class="bankbook">
            <span class="bankbook_title">（<b style="font-weight:normal;color:red;">{{$t('upgrade_page_views_withdrawalbenfit_withdraw_info_1665')}}</b>）</span>
            <el-upload
              class="bankbook-uploader"
              action="https://api.dev.nicee.app/basic/image/upload"
              :show-file-list="false"
              :http-request="handleBankbookSuccess"
              :before-upload="beforeAvatarUpload">
              <img v-if="withdrawData.bankBookImage" :src="withdrawData.bankBookImage" class="bankbook">
              <i v-else class="el-icon-plus bankbook-uploader-icon"></i>
            </el-upload>
            <div v-show="errors.bankBookImage" slot="tip" class="el-upload__text upload__tip">{{$t('upgrade_page_views_withdrawalbenfit_withdraw_info_1668')}}</div>
          </div>
          <p class="show-exist">{{$t('upgrade_page_views_withdrawalbenfit_withdraw_info_1669')}}</p>
          <el-image 
            :style="{
              transfrom: 0.75
            }" 
            class="show-exist-img"
            :src="bankbookExisturl"
            alt=""
            :preview-src-list="bankbookExisturlArr" />
          <div class="IDCard_dec">
            <p>{{$t('upgrade_page_views_withdrawalbenfit_withdraw_info_1651')}}</p>
            <p>{{$t('upgrade_page_views_withdrawalbenfit_withdraw_info_1672')}}</p>
            <p>{{$t('upgrade_page_views_withdrawalbenfit_withdraw_info_1652')}}</p>
            <p>{{$t('upgrade_page_views_withdrawalbenfit_withdraw_info_1653')}}</p>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <button class="with-draw-btn" @click.stop="submit">
      <i v-if="submiting" class="el-icon-loading"></i>
      <span v-else>{{$t('components_order_order_card_525')}}</span>
    </button>
  </div>
</template>
<script>
import i18n from '../../../locales/index'


import { uploadImageToS3 } from '@/api'
import { IDCardPlaceList } from './data'
import BankList from '@/upgrade-page/views/withdrawalBenfit/bank'
export default {
  data() {
    let withdrawData =  {
      memberUnified: '',
      memberName: '',
      managerNameE: '',
      loginAccount: '',
      memberPhone: '',
      managerMobile: '',
      managerEmail: '',
      merchantAddrArea: '',
      merchantAddrCode: '',
      merchantAddrCity: '',
      merchantAddr: '',
      bankCode: '',
      subBankCode: '',
      idCardDate: '',
      idFrom: '',
      idPic: '',
      idCardPlace: '',
      bankAccount: '',
      cityE: '',
      idCardImageBack: '',
      bankBookImage: '',
      idCardImage: '',
      bankName: ''
    }
    const errors = {}
    for (var i in withdrawData) {
      errors[i] = false
    }
    return {
      withdrawData,
      BankList,
      errors,
      IDCardPlaceList,
      idPicList: [
        {
          label: i18n.t('upgrade_page_views_withdraw_save_info_2390'),
          value: 1,
        },
        {
          label: i18n.t('upgrade_page_views_withdraw_save_info_2391'),
          value: 0,
        }
      ],
      idFromList: [
        {
          label: i18n.t('upgrade_page_views_withdraw_save_info_2392'),
          value: 1,
        },
        {
          label: i18n.t('upgrade_page_views_withdraw_save_info_2393'),
          value: 2,
        },
        {
          label: i18n.t('upgrade_page_views_withdraw_save_info_2394'),
          value: 3,
        },
      ],
      submiting: false,
      bankbookExisturl:require('@/assets/images/bankbook.png'),
      bankbookExisturlArr: [
        require('@/assets/images/bankbook.png'),
      ],
    }
  },
  methods: {
    handleSelectBank() {
      BankList.forEach((value) => {
        if (value.bankCode === this.withdrawData.bankCode) {
          this.withdrawData.bankName = value.bankName
          return
        }
      })
    },
    // 驗證身份證圖片
    handleAvatarSuccessP({ file }){
      const fd = new FormData()
      fd.append('file', file)
      uploadImageToS3(fd).then(({data}) => {
        this.identityFrontImg = data
        this.withdrawData.idCardImage = data
        this.errors.idCardImage = false
      })
    },
    // 驗證身份證圖片
    handleAvatarSuccessO({ file }){
      const fd = new FormData()
      fd.append('file', file)
      uploadImageToS3(fd).then(({data}) => {
        this.identityBackImg = data
        this.withdrawData.idCardImageBack = data
        this.errors.idCardImageBack = false;
      })
    },
    // 驗證銀行存摺圖
    handleBankbookSuccess({ file }){
      const fd = new FormData()
      fd.append('file', file)
      uploadImageToS3(fd).then(({data}) => {
        this.bankbookImg = data
        this.withdrawData.bankBookImage = data
        this.errors.bankBookImage = false
      })
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'||'image/jpg'||'image/png';
      const isLt2M = file.size / 1024 / 1024 < 3;

      if (!isJPG) {
        this.$message.error(i18n.t('upgrade_page_views_withdrawalbenfit_withdrawatm_1641'));
      }
      if (!isLt2M) {
        this.$message.error(i18n.t('upgrade_page_views_user_info_index_751'));
      }
      return isJPG && isLt2M;
    },
    idCardVerify() {
      if (/^\d{7}$/.test(this.withdrawData.idCardDate)) {
        this.$set(this.errors, 'idCardDate', false)
      } else {
        this.$set(this.errors, 'idCardDate', true)
      }
    },
    idCardNumberVerify() {
      if (/^[A-Z]\d{9}$/.test(this.withdrawData.memberUnified)) {
        this.$set(this.errors, 'memberUnified', false)
      } else {
        this.$set(this.errors, 'memberUnified', true)
      }
    },
    memberPhoneVerify() {
      const { memberPhone } = this.withdrawData
      if (/^((0\d)|(09\d{2}))-\d{6}$/.test(memberPhone)) {
        this.$set(this.errors, 'memberPhone', false)
      } else {
        this.$set(this.errors, 'memberPhone', true)
      }
    },
    managerNameEVerify() {
      const { managerNameE } = this.withdrawData
      if (/^\w+(\s+\w+)*\s*,\s*\w+$/.test(managerNameE)) {
        this.$set(this.errors, 'managerNameE', false)
      } else {
        this.$set(this.errors, 'managerNameE', true)
      }
    },
    managerMobileVerify() {
      const { managerMobile } = this.withdrawData
      if (/^09\d{8}$/.test(managerMobile)) {
        this.$set(this.errors, 'managerMobile', false)
      } else {
        this.$set(this.errors, 'managerMobile', true)
      }
    },
    managerEmailVerify() {
      const { managerEmail } = this.withdrawData
      if (/^(\w+\.)*\w+@\w+(.\w+)+$/.test(managerEmail)) {
        this.$set(this.errors, 'managerEmail', false)
      } else {
        this.$set(this.errors, 'managerEmail', true)
      }
    },
    loginAccountVerify() {
      const { loginAccount } = this.withdrawData
      if (/^[0-9a-zA-Z_.@]{5,20}$/.test(loginAccount)) {
        this.$set(this.errors, 'loginAccount', false)
      } else {
        this.$set(this.errors, 'loginAccount', true)
      }
    },
    submit(){
      if (this.submiting) return
      this.submiting = true
      const { withdrawData } = this
      let has_error = false
      for (var attr in withdrawData) {
        if (withdrawData[attr] === '' || this.errors[attr]) {
          this.$set(this.errors, attr, true)
          has_error = true
        }
      }
      if (has_error) {
        this.submiting = false
        return
      }
      this.$confirm({
        content: i18n.t('upgrade_page_views_withdraw_save_info_2395'),
        title: i18n.t('upgrade_page_views_withdraw_save_info_2396'),
        confirmButtonText: i18n.t('components_order_order_card_563'),
        cancelButtonText: i18n.t('upgrade_page_layout_header_42'),
      }).then(() => {
        // 保存
        this.$http.post('/withdraw/bank/save', withdrawData)
          .then(() => {
            this.submiting = false
            this.$router.go(-1)
          })
          .catch(({ msg }) => {
            this.submiting = false
            this.$message.error(msg)
          })
      }).catch(() => {
        this.submiting = false
      })
    },
  },
}
</script>
<style lang="scss" scoped>
  .page-container {
    max-width: 1200px;
    margin: 37px auto 56px;
    padding-bottom: 97px;
    background: #FFF;
    .page-title {
      height: 94px;
      line-height: 94px;
      text-align: center;
      border-bottom: 1px solid #F4F4F4;
      font-weight: 500;
      font-size: 22px;
      color: #333333;
    }
    .with-draw-btn {
      display: block;
      margin: 40px 0 0 269px;
      width: 168px;
      height: 48px;
      border-radius: 50px;
      background: $color-yellow;
      font-weight: 500;
      font-size: 16px;
      line-height: 48px;
      text-align: center;
      letter-spacing: -0.000319808px;
      color: $color-gray-1;
      .el-icon-loading {
        font-size: 20px;
      }
    }
  }
  .from-title {
    margin: 56px 40px 22px;
    height: 24px;
    padding-left: 11px;
    position: relative;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #333333;
    &::before {
      content: '';
      position: absolute;
      top: 3px;
      bottom: 3px;
      left: 0;
      width: 4px;
      background: $color-yellow;
    }
  }
  .UploadIDCard{
    width: 505px;
    @include flex(center,top);
    .IDCard_dec{
      width: 200px;
      margin-top: 25px;
      p{
        width: 200px;
        font-size:12px;
        line-height: 12px;
        margin-bottom: 5px;
        color:#999999;
      }
    }
    .UploadIDCard_Positive{
      height:127px;
      margin-left: 6px;
      .el-upload__text{
        margin-top: 5px;
        font-weight: 500;
        font-size: 12px;
        line-height: 17px;
        color: #FD2243;
      }
      .Positive_title{
        display: inline-block;
        margin-top: 4px;
        color: #333333;
        padding-right: 16px;
      }
      .avatar-uploader{
        width: 124px;
        height: 72px;
        display: block;
        margin-top: 5px;
        border: 1px solid #000;
        border-radius: 4px;
        overflow: hidden;
        .avatar-uploader-icon {
          font-size: 14px;
          color: #000;
          width: 124px;
          height: 72px;
          line-height: 72px;
          text-align: center;
        }
        .avatar {
          width: 124px;
          height: 72px;
          border-radius: 4px;
          display: block;
        }
        .el-upload {
          border: 1px solid #FA006E;
          border-radius: 4px;
          cursor: pointer;
        }
      }
    }
    .UploadIDCard_Verso{
      margin: 0 30px;
      height:127px;
      .el-upload__text{
        margin-top: 5px;
        font-weight: 500;
        font-size: 12px;
        color: #FD2243;
        line-height: 17px;
      }
      .Verso_title{
        display: inline-block;
        margin-top: 4px;
        color: #333333;
        padding-right: 16px;
      }
      .avatar-uploader{
        width: 124px;
        height: 72px;
        display: block;
        margin-top: 5px;
        border: 1px solid #000;
        border-radius: 4px;
        overflow: hidden;
        .avatar-uploader-icon {
          font-size: 14px;
          color: #000;
          width: 124px;
          height: 72px;
          line-height: 72px;
          text-align: center;
        }
        .avatar {
          width: 124px;
          height: 72px;
          border-radius: 4px;
          display: block;
        }
        .el-upload {
          border: 1px solid #FA006E;
          border-radius: 4px;
          cursor: pointer;
        }
      }
    }
  }
  .uploadBankbook {
    width: 600px;
    align-items: center;
    @include flex(flex-start, center);
    .show-exist {
      margin: 0 13px 0 0px;
      font-style: normal;
      font-weight: 500;
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #666666;
    }
    .show-exist-img {
      width: 119px;
      height: 74px;
      position: relative;
      bottom: 3px;
      margin-right: 32px;
    }
    .IDCard_dec{
      width: 200px;
      height: 74px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      p{
        width: 200px;
        font-size:12px;
        line-height: 12px;
        margin-bottom: 5px;
        color:#999999;
      }
    }
    .bankbook{
      height: 176px;
      .el-upload__text{
        margin-top: 5px;
        font-weight: 500;
        font-size: 12px;
        line-height: 17px;
        color: #FD2243;
      }
      .bankbook_title{
        display: inline-block;
        margin-top: 4px;
        color: #333333;
        padding-right: 16px;
      }
      .bankbook-uploader{
        height: 72px;
        display: block;
        margin-top: 5px;
        border: 1px solid #000;
        border-radius: 4px;
        margin-right: 20px;
        overflow: hidden;
        .bankbook-uploader-icon {
          font-size: 14px;
          color: #000;
          width: 124px;
          height: 72px;
          line-height: 72px;
          text-align: center;
        }
        .bankbook {
          width: 124px;
          height: 72px;
          border-radius: 4px;
          display: block;
        }
        .el-upload {
          border: 1px solid #FA006E;
          border-radius: 4px;
          cursor: pointer;
        }
      }
    }
  }
  .message-info {
    font-size: 16px;
    padding-top: 18px;
    .el-form-item {
      display: flex;
      .text-error {
        position: absolute;
        white-space: nowrap;
        left: 0;
        top: 100%;
        color: #FF0D0D;
        font-size: 14px;
        line-height: 20px;
      }
      /deep/ .el-form-item__label {
        width: 268px;
        text-align: right;
        line-height: 48px;
        color: #333333;
        padding-right: 16px;
      }
      /deep/.errors-style {
        input, textarea {
          border-color: #EE5A5A;
        }
      }
      /deep/ input {
        height: 48px;
        box-sizing: border-box;
        line-height: 22px;
        border: 1px solid #666666;
        &[type=text], &[type=number] {
          font-size: 16px;
          width: 406px;
        }
      }
      /deep/ textarea {
        height: 48px;
        box-sizing: border-box;
        line-height: 22px;
        border: 1px solid #666666;
        font-size: 16px;
        width: 406px;
        height: auto;
      }
      /deep/ .el-select {
        input[type=text] {
          width: 170px;
          &::placeholder {
            color: #333333;
          }
        }
        .el-input__icon {
          color: #333333;
        }
        .el-input.is-focus .el-input__inner {
            border-color: #666666;
        }
      }
    }
  }
</style>
